<style scoped>
.schedule-faucet-block {
    width: 100%;
    height: 30px;
}

.schedule-faucet-block p {
    margin: 0;
    padding: 0;
    cursor: pointer;
}

.schedule-faucet-block.open-faucet {
    background-color: rgb(0, 110, 153);
    border: 2px solid rgb(0, 147, 206);
    border-radius: 3px;
}

.schedule-faucet-block.close-faucet {
    border: 2px solid rgb(0, 147, 206);
    border-radius: 3px;
    color: rgb(46, 84, 105);
}
</style>

<template>
<div class="schedule-faucet-block" :class="getCellClass" @click="changeScheduleStatus">
    <p>{{getText}}</p>
</div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'

export default {
    created() {
    },
    data() {
        return {
            faucet_day_status: this.status
        }
    },
    props: ['day', 'time', 'status', 'id_faucet', 'change_action'],
    methods: {
        changeScheduleStatus() {
            if (this.faucet_day_status == 'close') {
                this.faucet_day_status = 'open'
                // saveSchedulePosition(this, 'open')
            } else if (this.faucet_day_status == 'open') {
                this.faucet_day_status = 'close'
                // saveSchedulePosition(this, 'close')
            }

            this.change_action(this.day, this.time, this.faucet_day_status)
        }
    },
    computed: {
        getCellClass: function () {
            if (this.faucet_day_status == 'open') {
                return 'open-faucet'
            } else {
                return 'close-faucet'
            }
        },
        getText: function () {
            if (this.faucet_day_status == 'open') {
                return 'Открыт'
            } else {
                return 'Закрыт'
            }
        }
    },
    watch: {
        status: function (status, old_status) {
            console.log(status)
            this.faucet_day_status = status
        },
    },
}

function saveSchedulePosition(vue_obj, action) {
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)
    post_data.set('week_day', vue_obj.day)
    post_data.set('time', vue_obj.time)
    post_data.set('action', action)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/change_time_action',
            data: post_data
        })
        .then(function (request) {
            console.log(request)
        })
        .catch(function (error) {
            if (!!error.response.data.exception) {
                vue_obj.faucet_name_msg = error.response.data.exception
            }
            if (this.faucet_day_status == 'close') {
                this.faucet_day_status = 'open'
            } else if (this.faucet_day_status == 'open') {
                this.faucet_day_status = 'close'
            }
        })
}
</script>



// WEBPACK FOOTER //
// src/components/elements/schedule-mode-day-time.vue